import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const teamsModalStyles = makeStyles((theme: Theme) =>
    createStyles({
        addTeamButton: {
            padding: 0,
            fontSize: 12,
            minWidth: "auto",
            letterSpacing: "1.25px",
            textDecoration: "underline",
            color: theme.palette.button.hover1.from,
            "&:hover": {
                textDecoration: "underline",
                color: theme.palette.button.hover1.to,
            },
            "&:active": {
                color: theme.palette.button.selected,
            },
            "&.Mui-disabled": {
                color: theme.palette.text.disabled,
            },
        },
        cancelButton: {
            fontSize: 12,
            color: theme.palette.primary.dark,
            padding: theme.spacing(0, 1, 0, 0),
            minWidth: "auto",
            "&.Mui-disabled": {
                color: theme.palette.text.disabled,
            },
            "& .MuiButton-startIcon": {
                marginRight: theme.spacing(0.5),
            },
        },
        checkboxes: {
            padding: theme.spacing(0.5),
            "& > .MuiSvgIcon-root": {
                fontSize: 14,
            },
        },
        column: {
            display: "flex",
            flexDirection: "column",
            width: "25%",
        },
        columnItem: {
            display: "flex",
            alignItems: "center",
            marginBottom: theme.spacing(1),
        },
        mainWrapper: {
            minHeight: 450,
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(2),
            borderRadius: 8,
            position: "absolute",
            boxShadow: "0px 6px 18px 1px rgba(0, 0, 0, 0.25)",
        },
        mainWrapperWide: {
            width: "calc((100% - 360px) * 0.95)",
            left: 360,
        },
        mainWrapperNarrow: {
            width: "calc((100% - 480px) * 0.8)",
            left: 480,
        },
        pagination: {
            marginTop: "auto",
            "& .MuiPagination-ul": {
                padding: theme.spacing(1, 0, 1, 0),
                justifyContent: "center",
            },
            "& .MuiPaginationItem-root": {
                color: theme.palette.text.primary,
                fontSize: "12px",
            },
            "& .Mui-selected": {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.common.white,
            },
        },
        pillCounter: {
            width: 20,
            height: 20,
            borderRadius: "40px",
            backgroundColor: theme.palette.info.main,
            color: theme.palette.common.white,
            fontSize: 8,
            fontWeight: 600,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: theme.spacing(0.5),
            flex: "0 0 auto",
        },
        searchBar: {
            marginBottom: theme.spacing(2),
            "& .MuiInputBase-input": {
                height: 22,
            },
            "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                fontSize: 16,
            },
        },
    })
);

export default teamsModalStyles;
